export default [5, 10, 25, 50];
